import React from 'react';
import { Link } from 'react-router-dom';
import Meta from '../components/Meta';

export default function Error403() {
  return (
    <>
      <Meta title="403 - Adgang nægtet | Chr. Nielsen & Søn" description="Adgang nægtet." pageTitle="403" />

      <section className="min-h-[70vh] flex items-center justify-center bg-brand-dark px-4 py-24 relative overflow-hidden">
        {/* Decorative background elements */}
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-brand-red/5 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-brand-green/5 rounded-full blur-3xl pointer-events-none" />

        <div className="relative z-10 max-w-md w-full text-center space-y-8 bg-brand-dark-card border border-brand-dark-border rounded-lg p-8 sm:p-12 shadow-2xl">
          <div className="inline-flex items-center justify-center h-20 w-20 rounded-full bg-brand-red/10 border border-brand-red/20 text-brand-red text-4xl">
            <i className="fa-solid fa-lock" />
          </div>

          <div className="space-y-3">
            <h1 className="text-4xl sm:text-6xl font-extrabold text-white font-mono tracking-wider">403</h1>
            <h2 className="text-lg sm:text-xl font-bold text-white uppercase tracking-wide">Adgang nægtet</h2>
            <p className="text-sm text-gray-400 leading-relaxed">
              Du har ikke tilladelse til at tilgå denne ressource. Venligst kontakt administratoren, hvis du mener, dette er en fejl.
            </p>
          </div>

          <div className="pt-4">
            <Link 
              to="/" 
              className="inline-flex items-center gap-2 px-6 py-3 bg-brand-red hover:bg-brand-red-hover text-white rounded-md font-bold text-sm uppercase tracking-wider transition-colors"
            >
              <i className="fa-solid fa-house" />
              Gå til forsiden
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
